/*
Copyright (c) 2021.
*/

import maverickPortalhttp from '../../webService/webService';
import maverickPortalApiEndPoint from '../../../config/apiEndPoint';
import AuthService from '../../authService/AuthService';

const analysisData = data => {
  return new Promise(function request(resolve) {
    maverickPortalhttp
      .makeRequest(
        maverickPortalApiEndPoint.getAnalysisData.url,
        maverickPortalApiEndPoint.getAnalysisData.methodType,
        data
      )
      .then(response => {
        // if (response.data.Response !== undefined && response.data.Response?.token_data.access_token.length) {
        //    AuthService.login(response.data.Response.token_data.access_token);
        // }
        // else {
        //   console.log(response.data?.Status.StatusDesc)
        // }
        const res = response.data;
        resolve({ res });
      });
  });
};

const analysisScreenerData = data => {
  return new Promise(function request(resolve) {
    maverickPortalhttp
      .makeRequest(
        maverickPortalApiEndPoint.getScreenerAnalysisData.url,
        maverickPortalApiEndPoint.getScreenerAnalysisData.methodType,
        data
      )
      .then(response => {
        const res = response.data;
        resolve({ res });
      });
  });
};

const analysisCsv = data => {
  return new Promise(function request(resolve) {
    maverickPortalhttp
      .makeRequest(
        maverickPortalApiEndPoint.getAnalysisCsv.url,
        maverickPortalApiEndPoint.getAnalysisCsv.methodType,
        data
      )
      .then(response => {
        // if (response.data.Response !== undefined && response.data.Response?.token_data.access_token.length) {
        //    AuthService.login(response.data.Response.token_data.access_token);
        // }
        // else {
        //   console.log(response.data?.Status.StatusDesc)
        // }
        const res = response.data;
        resolve({ res });
      });
  });
};

const analysisCsvWithCode = data => {
  return new Promise(function request(resolve) {
    maverickPortalhttp
      .makeRequest(
        maverickPortalApiEndPoint.getAnalysisCsvWithCode.url,
        maverickPortalApiEndPoint.getAnalysisCsvWithCode.methodType,
        data
      )
      .then(response => {
        // if (response.data.Response !== undefined && response.data.Response?.token_data.access_token.length) {
        //    AuthService.login(response.data.Response.token_data.access_token);
        // }
        // else {
        //   console.log(response.data?.Status.StatusDesc)
        // }
        const res = response.data;
        resolve({ res });
      });
  });
};

// const logout = () => {
//   return new Promise(function request(resolve) {
//     AuthService.logout();
//   resolve(true);
//   });
// };

export { analysisData, analysisScreenerData, analysisCsv, analysisCsvWithCode };
